<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 animate-fade-in shadow-none">
        <div class="card-body p-3">
          <!-- Header -->
          <div class="d-flex align-items-center gap-3 mb-4">
            <button class="btn btn-soft-secondary btn-sm" (click)="goBack()">
              <i class="bi bi-arrow-left"></i>
            </button>
            <div>
              <h1 class="card-title mb-0">
                {{ employeeName || 'Attendance Detail' }}
              </h1>
              <span class="sub-text">Today's attendance record — {{ today | date: 'EEEE, dd MMMM yyyy' }}</span>
            </div>
          </div>

          @if (isLoading) {
            <app-loading-spinner></app-loading-spinner>
          } @else {
            <!-- No data state -->
            @if (!logs.length) {
              <div class="text-center py-5">
                <i class="bi bi-calendar-x text-muted display-4"></i>
                <p class="text-muted mt-3">No attendance record found for today.</p>
              </div>
            } @else {
              <!-- Summary strip -->
              <div class="row g-3 mb-4">
                <div class="col-6 col-md-3">
                  <div class="info-card d-flex align-items-center p-3 border gap-3">
                    <div class="icon-circle green-icon-bg bg-opacity-10 green-icon">
                      <i class="bi bi-box-arrow-in-right"></i>
                    </div>
                    <div>
                      <div class="text-muted small">First Check-in</div>
                      <div class="fw-semibold">
                        {{ firstCheckIn ? (firstCheckIn | date: 'hh:mm a') : '—' }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 col-md-3">
                  <div class="info-card d-flex align-items-center p-3 border gap-3">
                    <div class="icon-circle blue-icon-bg bg-opacity-10 blue-icon">
                      <i class="bi bi-box-arrow-right"></i>
                    </div>
                    <div>
                      <div class="text-muted small">Last Check-out</div>
                      <div class="fw-semibold">
                        {{ lastCheckOut ? (lastCheckOut | date: 'hh:mm a') : '—' }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 col-md-3">
                  <div class="info-card d-flex align-items-center p-3 border gap-3">
                    <div class="icon-circle orange-icon-bg bg-opacity-10 orange-icon">
                      <i class="bi bi-speedometer2"></i>
                    </div>
                    <div>
                      <div class="text-muted small">Opening KM</div>
                      <div class="fw-semibold">{{ totalOpeningKm }}</div>
                    </div>
                  </div>
                </div>

                <div class="col-6 col-md-3">
                  <div class="info-card d-flex align-items-center p-3 border gap-3">
                    <div class="icon-circle purple-icon-bg bg-opacity-10 purple-icon">
                      <i class="bi bi-signpost-split"></i>
                    </div>
                    <div>
                      <div class="text-muted small">Total KM Travelled</div>
                      <div class="fw-semibold">
                        {{ totalKmTravelled > 0 ? totalKmTravelled + ' km' : '—' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Google Maps Route -->
              <div class="card border mb-4">
                <div class="card-header">
                  <i class="bi bi-map me-2"></i>
                  Route / Location Playback
                </div>
                <div class="card-body p-0">
                  @if (hasMapData) {
                    <google-map height="380px" width="100%" [center]="mapCenter" [zoom]="zoom">
                      <map-marker
                        #ciMarker="mapMarker"
                        *ngFor="let m of checkInMarkers"
                        [position]="m.position"
                        [label]="m.label"
                        [title]="'Check-in: ' + m.label"
                        (mapMouseover)="onMarkerHover(ciMarker, m, 'check-in')"
                        (mapMouseout)="onMarkerOut()"></map-marker>
                      <map-marker
                        #coMarker="mapMarker"
                        *ngFor="let m of checkOutMarkers"
                        [position]="m.position"
                        [label]="m.label"
                        [title]="'Check-out: ' + m.label"
                        (mapMouseover)="onMarkerHover(coMarker, m, 'check-out')"
                        (mapMouseout)="onMarkerOut()"></map-marker>
                      <map-polyline
                        *ngFor="let path of polylinePaths"
                        [path]="path"
                        [options]="{ strokeColor: '#4285F4', strokeWeight: 3, strokeOpacity: 0.8 }"></map-polyline>
                      <map-polyline
                        *ngFor="let path of travelPaths"
                        [path]="path"
                        [options]="{ strokeColor: '#fd7e14', strokeWeight: 2, strokeOpacity: 0.7 }"></map-polyline>
                      <map-info-window>
                        @if (activeMarkerInfo) {
                          <div style="font-size: 0.8rem; min-width: 160px; line-height: 1.6">
                            <div class="fw-semibold mb-1">
                              <span [style.color]="activeMarkerInfo.type === 'check-in' ? '#198754' : '#0dcaf0'">
                                {{ activeMarkerInfo.type === 'check-in' ? '▶ Check-in' : '◼ Check-out' }}
                              </span>
                              &nbsp;·&nbsp;{{ activeMarkerInfo.label }}
                            </div>
                            <div>🕐 {{ activeMarkerInfo.time | date: 'hh:mm a' }}</div>
                            @if (activeMarkerInfo.address) {
                              <div style="color: #6c757d; margin-top: 2px">📍 {{ activeMarkerInfo.address }}</div>
                            }
                          </div>
                        }
                      </map-info-window>
                    </google-map>
                  } @else {
                    <div class="text-center py-5 text-muted">
                      <i class="bi bi-geo-alt display-4"></i>
                      <p class="mt-3">No location data available.</p>
                    </div>
                  }
                </div>
              </div>

              <!-- Session logs -->
              <h6 class="fw-bold mb-3 text-uppercase text-muted" style="font-size: 0.7rem; letter-spacing: 0.06em">
                Session Details
              </h6>

              <div *ngFor="let log of logs; let i = index" class="card border mb-3">
                <div class="card-header d-flex align-items-center justify-content-between">
                  <span class="fw-semibold">
                    Session {{ i + 1 }}
                    <span class="text-muted fw-normal small ms-1">({{ log.tour_purpose }})</span>
                  </span>
                  <span class="app-badge" [ngClass]="log.check_out ? 'badge-success' : 'badge-warning'">
                    {{ log.check_out ? 'Completed' : 'In Progress' }}
                  </span>
                </div>

                <div class="card-body">
                  <!-- Check-in / Check-out times & locations -->
                  <div class="row g-3 mb-3">
                    <div class="col-md-6">
                      <div class="p-3 bg-light rounded border">
                        <div class="text-muted small fw-bold text-uppercase mb-2" style="font-size: 0.65rem">
                          <i class="bi bi-box-arrow-in-right me-1 text-success"></i>
                          Check-in
                        </div>
                        <div class="fw-semibold text-primary">{{ log.check_in | date: 'hh:mm a' }}</div>
                        <div class="small text-muted mt-1">
                          <i class="bi bi-calendar3 me-1"></i>
                          {{ log.check_in | date: 'dd MMM yyyy' }}
                        </div>
                        <div class="small text-muted mt-1" *ngIf="log.check_in_location?.address">
                          <i class="bi bi-geo-alt me-1"></i>
                          {{ log.check_in_location.address }}
                        </div>
                        <img
                          *ngIf="log.check_in_image"
                          [src]="log.check_in_image"
                          class="rounded mt-2 border shadow-sm"
                          style="width: 90px; height: 90px; object-fit: cover; cursor: pointer"
                          title="Click to preview"
                          (click)="openImagePreview(log.check_in_image)"
                          (error)="handleImageError($event)" />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="p-3 bg-light rounded border">
                        <div class="text-muted small fw-bold text-uppercase mb-2" style="font-size: 0.65rem">
                          <i class="bi bi-box-arrow-right me-1 text-info"></i>
                          Check-out
                        </div>
                        @if (log.check_out) {
                          <div class="fw-semibold text-primary">{{ log.check_out | date: 'hh:mm a' }}</div>
                          <div class="small text-muted mt-1">
                            <i class="bi bi-calendar3 me-1"></i>
                            {{ log.check_out | date: 'dd MMM yyyy' }}
                          </div>
                          <div class="small text-muted mt-1" *ngIf="log.check_out_location?.address">
                            <i class="bi bi-geo-alt me-1"></i>
                            {{ log.check_out_location!.address }}
                          </div>
                          <img
                            *ngIf="log.check_out_image"
                            [src]="log.check_out_image"
                            class="rounded mt-2 border shadow-sm"
                            style="width: 90px; height: 90px; object-fit: cover; cursor: pointer"
                            title="Click to preview"
                            (click)="openImagePreview(log.check_out_image)"
                            (error)="handleImageError($event)" />
                        } @else {
                          <div class="text-muted fst-italic small mt-1">Not yet checked out</div>
                        }
                      </div>
                    </div>
                  </div>

                  <!-- KM & Vehicle details -->
                  <div class="p-3 bg-white rounded border d-flex flex-wrap gap-4 mb-3">
                    <div>
                      <div class="text-muted fw-bold text-uppercase" style="font-size: 0.6rem">Opening KM</div>
                      <div class="fw-medium small">{{ log.opening_km ?? '—' }}</div>
                    </div>
                    <div>
                      <div class="text-muted fw-bold text-uppercase" style="font-size: 0.6rem">Closing KM</div>
                      <div class="fw-medium small">{{ log.closing_km ?? '—' }}</div>
                    </div>
                    <div>
                      <div class="text-muted fw-bold text-uppercase" style="font-size: 0.6rem">Total KM</div>
                      <div class="fw-medium small">
                        {{
                          log.closing_km != null && log.opening_km != null
                            ? log.closing_km - log.opening_km + ' km'
                            : '—'
                        }}
                      </div>
                    </div>
                    <div>
                      <div class="text-muted fw-bold text-uppercase" style="font-size: 0.6rem">Vehicle</div>
                      <div class="fw-medium small">{{ log.vehicle_type || '—' }}</div>
                    </div>
                    <div>
                      <div class="text-muted fw-bold text-uppercase" style="font-size: 0.6rem">Tour Type</div>
                      <div class="fw-medium small">{{ log.tour_type || '—' }}</div>
                    </div>
                    <div>
                      <div class="text-muted fw-bold text-uppercase" style="font-size: 0.6rem">Tour Purpose</div>
                      <div class="fw-medium small">{{ log.tour_purpose || '—' }}</div>
                    </div>
                    <div>
                      <div class="text-muted fw-bold text-uppercase" style="font-size: 0.6rem">Place to Visit</div>
                      <div class="fw-medium small">{{ log.place_to_visit || '—' }}</div>
                    </div>
                  </div>

                  <!-- Selfie -->
                  <div *ngIf="log.employee_selfie" class="mb-3">
                    <div class="text-muted small fw-bold text-uppercase mb-1" style="font-size: 0.65rem">
                      Employee Selfie
                    </div>
                    <img
                      [src]="log.employee_selfie"
                      class="rounded border shadow-sm"
                      style="width: 90px; height: 90px; object-fit: cover; cursor: pointer"
                      title="Click to preview"
                      (click)="openImagePreview(log.employee_selfie!)"
                      (error)="handleImageError($event)" />
                  </div>

                  <!-- Party Visits -->
                  <div *ngIf="log.party_visits?.length">
                    <div class="text-muted small fw-bold text-uppercase mb-2" style="font-size: 0.65rem">
                      Party Visits
                    </div>
                    <div class="table-responsive border rounded">
                      <table class="table table-sm mb-0">
                        <thead class="table-light">
                          <tr>
                            <th class="ps-3 py-2 small">Dealer / Shop</th>
                            <th class="py-2 small">Status</th>
                            <th class="py-2 small">Check-in</th>
                            <th class="py-2 small">Check-out</th>
                            <th class="py-2 small">Remarks</th>
                            <th class="py-2 small">Image</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let pv of log.party_visits">
                            <td class="ps-3 py-2">
                              <div class="fw-medium small">{{ pv.dealer?.shop_name }}</div>
                              <div class="text-muted" style="font-size: 0.7rem">
                                {{ pv.dealer?.first_name }} {{ pv.dealer?.last_name }}
                              </div>
                            </td>
                            <td class="py-2">
                              <span
                                class="app-badge"
                                [ngClass]="
                                  pv.visit_status === 'Completed' ? 'badge-soft-success' : 'badge-soft-warning'
                                ">
                                {{ pv.visit_status }}
                              </span>
                            </td>
                            <td class="py-2 small">
                              {{ pv.visit_check_in ? (pv.visit_check_in | date: 'hh:mm a') : '—' }}
                            </td>
                            <td class="py-2 small">
                              {{ pv.visit_check_out ? (pv.visit_check_out | date: 'hh:mm a') : '—' }}
                            </td>
                            <td class="py-2 small text-muted">
                              {{ pv.visit_remarks || pv.cancel_reason_display || '—' }}
                            </td>
                            <td class="py-2">
                              <img
                                *ngIf="pv.visit_image"
                                [src]="pv.visit_image"
                                class="rounded border"
                                style="width: 50px; height: 50px; object-fit: cover; cursor: pointer"
                                title="Click to preview"
                                (click)="openImagePreview(pv.visit_image!)"
                                (error)="handleImageError($event)" />
                              <span *ngIf="!pv.visit_image" class="text-muted small">—</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Full-screen image preview modal -->
<ng-template #imagePreviewModal let-modal>
  <div class="modal-header border-0 pb-0">
    <button type="button" class="btn-close ms-auto" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body text-center p-2">
    <img
      [src]="previewImageUrl"
      class="img-fluid rounded"
      style="max-height: 80vh; object-fit: contain"
      (error)="handleImageError($event)" />
  </div>
</ng-template>
